import { INITIAL_STATE } from "../../../reducers";
import {
  GET_CALENDARS,
  SELECT_CALENDAR,
  CHECK_CALENDAR,
  SET_CONFIG_HOURS_CALENDAR,
  ERROR_CALENDARS
} from "./sidebar.actions";

export const calendarsResult = (state = INITIAL_STATE.calendarsResult, action) => {
  switch (action.type) {
    case GET_CALENDARS:
      return {
        ...state,
        calendars: action.payload
      };
    case SELECT_CALENDAR:
      return {
        ...state,
        calendars: state.calendars.map(el => {
          if (el.id === action.payload.calendarId) {
            return {
              ...el,
              checked: action.payload.checked
            };
          }
          return el;
        })
      };

    case CHECK_CALENDAR: {
      return {
        ...state,
        calendars: state.calendars.map(cal =>
          cal.id === action.payload.calendarId
            ? { ...cal, checked: action.payload.checked }
            : cal
        )
      };
    }

    case SET_CONFIG_HOURS_CALENDAR:
      return {
        ...state,
        calendarTimeScale: action.payload.calendarTimeScale
      };

    case ERROR_CALENDARS:
      return {
        ...state,
        calendarError: action.payload
      };
      
    default:
      return state;
  }
};
